import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { NewquanlytonkhoAction } from 'src/actions/newquanlytonkho.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import Select from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

import { isGrantPermission } from 'src/utils/utils';
import { NewdanhmucnhacungcapAction } from 'src/actions/newdanhmucnhacungcap.action';

import CreateEditDialogNewdanhmucnhacungcap from '../newdanhmucnhacungcap-detail/CreateEditDialog';

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.newquanlytonkho)
    const { info, permissions, role } = useSelector(state => state.profile)
    const [ma, setMa] = useState("")
    const [ten, setTen] = useState("")
    const [gia_nhap, setGiaNhap] = useState("0")
    const [gia_thuc_nhap_si_1, setGiaThucNhapSi1] = useState("0")
    const [gia_thuc_nhap_si_2, setGiaThucNhapSi2] = useState("0")
    const [gia_thuc_nhap_si_3, setGiaThucNhapSi3] = useState("0")
    const [giaxuat1, setGiaXuat1] = useState("0")
    const [giaxuat2, setGiaXuat2] = useState("0")
    const [giaxuat3, setGiaXuat3] = useState("0")
    const [chiet_khau_1, setChietKhau1] = useState("0")
    const [chiet_khau_2, setChietKhau2] = useState("0")
    const [chiet_khau_3, setChietKhau3] = useState("0")

    const [nhacungcap_id, setNhacungcapId] = useState("-99");
    const [nhacungcap_name, setNhacungcapName] = useState("");
    const [nhacungcap_select, setNhacungcapSelect] = useState(undefined);
    const [nhacungcapList, setNhacungcapList] = useState([]);

    const additionalOptionNhacungcap = { 'id': '-99', 'ma': 'Nhà cung cấp...', 'ten': '' };

    const [openNewdanhmucnhacungcap, setOpenNewdanhmucnhacungcap] = useState(false);

    //==========

    const handleClickOpenNewdanhmucnhacungcap = () => {
        setOpenNewdanhmucnhacungcap(true);
    };

    const handleCloseNewdanhmucnhacungcap = () => {
        setOpenNewdanhmucnhacungcap(false);
        fetchData();
    };

    //==========

    const fetchData = async() => {
        const _nhacungcapList = await dispatch(NewdanhmucnhacungcapAction.nhacungcapList());
        if (_nhacungcapList && typeof _nhacungcapList.data !== 'undefined' && typeof _nhacungcapList.data.values !== 'undefined') setNhacungcapList(_nhacungcapList.data.values);
    }

    useEffect(() => {
        if (props.open == true) {
            fetchData();

            resetState();

            if (props.type == 'EDIT' && selected) {
                setMa(selected.ma)
                setTen(selected.ten)
                setGiaNhap(Number(selected.gia_nhap))
                setGiaThucNhapSi1(Number(selected.gia_thuc_nhap_si_1))
                setGiaThucNhapSi2(Number(selected.gia_thuc_nhap_si_2))
                setGiaThucNhapSi3(Number(selected.gia_thuc_nhap_si_3))
                setGiaXuat1(Number(selected.giaxuat1))
                setGiaXuat2(Number(selected.giaxuat2))
                setGiaXuat3(Number(selected.giaxuat3))
                setChietKhau1(Number(selected.chiet_khau_1))
                setChietKhau2(Number(selected.chiet_khau_2))
                setChietKhau3(Number(selected.chiet_khau_3))

                if (typeof selected.newdanhmucnhacungcap_ref !== 'undefined' && selected.newdanhmucnhacungcap_ref) {
                    const newValue = selected.newdanhmucnhacungcap_ref;

                    const nhacungcapLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                
                    const html = `
                        <div>
                            ${nhacungcapLine}
                        </div>
                    `;
                    
                    setNhacungcapId(selected.newdanhmucnhacungcap_ref.id);
                    setNhacungcapName(html);
                    setNhacungcapSelect(selected.newdanhmucnhacungcap_ref);
                }
            }
        }
    }, [props])

    const onPressPositive = () => {
        if (ma === "") {
            alert('Vui lòng nhập mã!');
            return;
        }

        if (ten === "") {
            alert('Vui lòng nhập tên!');
            return;
        }

        if (gia_nhap === "") {
            setGiaNhap("0");
        }

        if (gia_thuc_nhap_si_1 === "") {
            setGiaThucNhapSi1("0");
        }

        if (gia_thuc_nhap_si_2 === "") {
            setGiaThucNhapSi2("0");
        }

        if (gia_thuc_nhap_si_3 === "") {
            setGiaThucNhapSi3("0");
        }

        if (giaxuat1 === "") {
            setGiaXuat1("0");
        }

        if (giaxuat2 === "") {
            setGiaXuat2("0");
        }

        if (giaxuat3 === "") {
            setGiaXuat3("0");
        }

        if (chiet_khau_1 === "") {
            setChietKhau1("0");
        }

        if (chiet_khau_2 === "") {
            setChietKhau2("0");
        }

        if (chiet_khau_3 === "") {
            setChietKhau3("0");
        }

        if (props.type === 'EDIT') {
            dispatch(NewquanlytonkhoAction.update(selected.id, { 
                ma, 
                ten, 
                don_vi_nhap: nhacungcap_id,
                gia_nhap: Number(gia_nhap), 
                gia_thuc_nhap_si_1: Number(gia_thuc_nhap_si_1),
                gia_thuc_nhap_si_2: Number(gia_thuc_nhap_si_2),
                gia_thuc_nhap_si_3: Number(gia_thuc_nhap_si_3),
                giaxuat1: Number(giaxuat1),
                giaxuat2: Number(giaxuat2),
                giaxuat3: Number(giaxuat3),
                chiet_khau_1: Number(chiet_khau_1),
                chiet_khau_2: Number(chiet_khau_2), 
                chiet_khau_3: Number(chiet_khau_3),
            }))
        } else {
            dispatch(NewquanlytonkhoAction.create({ 
                ma, 
                ten, 
                don_vi_nhap: nhacungcap_id,
                gia_nhap: Number(gia_nhap), 
                gia_thuc_nhap_si_1: Number(gia_thuc_nhap_si_1),
                gia_thuc_nhap_si_2: Number(gia_thuc_nhap_si_2),
                gia_thuc_nhap_si_3: Number(gia_thuc_nhap_si_3),
                giaxuat1: Number(giaxuat1),
                giaxuat2: Number(giaxuat2),
                giaxuat3: Number(giaxuat3),
                chiet_khau_1: Number(chiet_khau_1),
                chiet_khau_2: Number(chiet_khau_2), 
                chiet_khau_3: Number(chiet_khau_3),
            }, props.creatingFromAway))
        }
        resetState();
        props.handleClose();
    }

    const resetState = () => {
        setMa("")
        setTen("")
        setGiaNhap("0")
        setGiaThucNhapSi1("0")
        setGiaThucNhapSi2("0")
        setGiaThucNhapSi3("0")
        setChietKhau1("0")
        setChietKhau2("0")
        setChietKhau3("0")
        setGiaXuat1("0")
        setGiaXuat2("0")
        setGiaXuat3("0")
        setNhacungcapId("-99");
        setNhacungcapName("");
        setNhacungcapSelect(undefined);
        setNhacungcapList([]);
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
            <DialogContent style={{ width: 600, paddingTop: 20 }}>
                <Grid
                    container
                    spacing={3}
                >
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Mã"
                            name="ma"
                            onChange={(e) => setMa(e.target.value)}
                            required
                            value={ma}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Tên"
                            name="ten"
                            onChange={(e) => setTen(e.target.value)}
                            required
                            value={ten}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select has-fast-action-btn">
                            <Button
                                className="fast-action-btn"
                                color="primary"
                                variant="contained"
                                onClick={() => handleClickOpenNewdanhmucnhacungcap()}
                                style={{ 
                                    backgroundColor: 'orange',
                                }}
                            >
                                +
                            </Button>
                            <Select
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 56,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                }}
                                options={[additionalOptionNhacungcap, ...nhacungcapList]} // Thêm vào đầu danh sách
                                getOptionLabel={(item) =>
                                    `${item.ma + (item.ten ? (' - ' + item.ten) : '') + (typeof item.newdanhmucnhacungcap_ref !== 'undefined' ? (' (' + item.newdanhmucnhacungcap_ref.ma + ' - ' + item.newdanhmucnhacungcap_ref.ten + ')') : '')}`
                                }
                                formatOptionLabel={(item, { context }) => {
                                    const nhacungcapLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;

                                    return (
                                        <div>
                                            <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{nhacungcapLine}</div>
                                        </div>
                                    );
                                }}
                                placeholder={
                                    nhacungcap_id !== "-99"
                                        ? <span dangerouslySetInnerHTML={{ __html: nhacungcap_name }} />
                                        : <span style={{fontWeight: 'bold'}}>Nhà cung cấp...</span>
                                }
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={nhacungcap_id || null}
                                onChange={(newValue) => {
                                    const nhacungcapLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                                
                                    const html = `
                                        <div>
                                            ${nhacungcapLine}
                                        </div>
                                    `;
                                
                                    setNhacungcapId(newValue.id);
                                    setNhacungcapName(html);
                                    setNhacungcapSelect(newValue);
                                }}
                                isSearchable
                            />
                        </div>
                    </Grid>
                    {isGrantPermission(permissions, ["newquanlytonkho.gianhap"]) && <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <TextField
                            fullWidth
                            label="Giá nhập"
                            name="gia_nhap"
                            onChange={(e) => {
                                setGiaNhap(e.target.value);
                                setGiaThucNhapSi1(parseInt(Number(e.target.value) / 100 * (100 - Number(chiet_khau_1))));
                                setGiaThucNhapSi2(parseInt(Number(e.target.value) / 100 * (100 - Number(chiet_khau_2))));
                                setGiaThucNhapSi3(parseInt(Number(e.target.value) / 100 * (100 - Number(chiet_khau_3))));
                            }}
                            required
                            value={gia_nhap}
                            variant="outlined"
                        />
                    </Grid>}
                    {isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi1"]) && <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label={(isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi2"]) || isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi3"])) ? 'Chiết khấu 1 (%)' : 'Chiết khấu (%)'}
                            name="chiet_khau_1"
                            onChange={(e) => {
                                let chietKhau = e.target.value;
                                if (chietKhau < 0) chietKhau = 0;
                                if (chietKhau > 100) chietKhau = 100;
                                setChietKhau1(chietKhau);
                                setGiaThucNhapSi1(parseInt(Number(gia_nhap) / 100 * (100 - Number(chietKhau))));
                            }}
                            required
                            value={chiet_khau_1}
                            variant="outlined"
                        />
                    </Grid>}
                    {isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi1"]) && <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label={(isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi2"]) || isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi3"])) ? 'Giá NCC 1' : 'Giá thực nhập'}
                            name="gia_thuc_nhap_si_1"
                            onChange={(e) => {
                                setGiaThucNhapSi1(e.target.value);
                                setChietKhau1(Number(gia_nhap) != 0 && e.target.value != 0 ? (Number(gia_nhap) - Number(e.target.value)) / Number(gia_nhap) * 100 : 0);
                            }}
                            required
                            value={gia_thuc_nhap_si_1}
                            variant="outlined"
                        />
                    </Grid>}
                    {isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi2"]) && <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label={(isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi1"]) || isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi3"])) ? 'Chiết khấu 2 (%)' : 'Chiết khấu (%)'}
                            name="chiet_khau_2"
                            onChange={(e) => {
                                let chietKhau = e.target.value;
                                if (chietKhau < 0) chietKhau = 0;
                                if (chietKhau > 100) chietKhau = 100;
                                setChietKhau2(chietKhau);
                                setGiaThucNhapSi2(parseInt(Number(gia_nhap) / 100 * (100 - Number(chietKhau))));
                            }}
                            required
                            value={chiet_khau_2}
                            variant="outlined"
                        />
                    </Grid>}
                    {isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi2"]) && <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label={(isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi1"]) || isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi3"])) ? 'Giá NCC 2' : 'Giá thực nhập'}
                            name="gia_thuc_nhap_si_2"
                            onChange={(e) => {
                                setGiaThucNhapSi2(e.target.value);
                                setChietKhau2(Number(gia_nhap) != 0 && e.target.value != 0 ? (Number(gia_nhap) - Number(e.target.value)) / Number(gia_nhap) * 100 : 0);
                            }}
                            required
                            value={gia_thuc_nhap_si_2}
                            variant="outlined"
                        />
                    </Grid>}
                    {isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi3"]) && <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label={(isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi1"]) || isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi2"])) ? 'Chiết khấu 3 (%)' : 'Chiết khấu (%)'}
                            name="chiet_khau_3"
                            onChange={(e) => {
                                let chietKhau = e.target.value;
                                if (chietKhau < 0) chietKhau = 0;
                                if (chietKhau > 100) chietKhau = 100;
                                setChietKhau3(chietKhau);
                                setGiaThucNhapSi3(parseInt(Number(gia_nhap) / 100 * (100 - Number(chietKhau))));
                            }}
                            required
                            value={chiet_khau_3}
                            variant="outlined"
                        />
                    </Grid>}
                    {isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi3"]) && <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label={(isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi1"]) || isGrantPermission(permissions, ["newquanlytonkho.giathucnhapsi2"])) ? 'Giá NCC 3' : 'Giá thực nhập'}
                            name="gia_thuc_nhap_si_3"
                            onChange={(e) => {
                                setGiaThucNhapSi3(e.target.value);
                                setChietKhau3(Number(gia_nhap) != 0 && e.target.value != 0 ? (Number(gia_nhap) - Number(e.target.value)) / Number(gia_nhap) * 100 : 0);
                            }}
                            required
                            value={gia_thuc_nhap_si_3}
                            variant="outlined"
                        />
                    </Grid>}
                    {isGrantPermission(permissions, ["newquanlytonkho.giaxuat1"]) && <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <TextField
                            fullWidth
                            label={(isGrantPermission(permissions, ["newquanlytonkho.giaxuat2"]) || isGrantPermission(permissions, ["newquanlytonkho.giaxuat3"])) ? 'Giá xuất sỉ' : 'Giá xuất'}
                            name="giaxuat1"
                            onChange={(e) => {
                                setGiaXuat1(e.target.value);
                                
                            }}
                            required
                            value={giaxuat1}
                            variant="outlined"
                        />
                    </Grid>}
                    {isGrantPermission(permissions, ["newquanlytonkho.giaxuat2"]) && <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <TextField
                            fullWidth
                            label={(isGrantPermission(permissions, ["newquanlytonkho.giaxuat1"]) || isGrantPermission(permissions, ["newquanlytonkho.giaxuat3"])) ? 'Giá xuất CTV' : 'Giá xuất'}
                            name="giaxuat2"
                            onChange={(e) => {
                                setGiaXuat2(e.target.value);
                                
                            }}
                            required
                            value={giaxuat2}
                            variant="outlined"
                        />
                    </Grid>}
                    {isGrantPermission(permissions, ["newquanlytonkho.giaxuat3"]) && <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <TextField
                            fullWidth
                            label={(isGrantPermission(permissions, ["newquanlytonkho.giaxuat1"]) || isGrantPermission(permissions, ["newquanlytonkho.giaxuat2"])) ? 'Giá xuất KH lẻ' : 'Giá xuất'}
                            name="giaxuat3"
                            onChange={(e) => {
                                setGiaXuat3(e.target.value);
                                
                            }}
                            required
                            value={giaxuat3}
                            variant="outlined"
                        />
                    </Grid>}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Huỷ</Button>
                <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
            </DialogActions>
            <CreateEditDialogNewdanhmucnhacungcap open={openNewdanhmucnhacungcap} handleClose={handleCloseNewdanhmucnhacungcap} type={"CREATE"} creatingFromAway={true} />
        </Dialog >
    );
}

export default CreateEditDialog;